import { Card, Button, Icon } from '@circlefin/components'
import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'

export const LandingHeroCard = () => {
  const { t } = useTranslation('chatbot')
  return (
    <Card
      className="relative overflow-hidden bg-gradient-to-r from-[#F1EBFF] to-[#E1F2FF]"
      data-testid="hero-card"
    >
      {/* Background image - only visible on lg+ screens */}
      <div className="absolute inset-0 hidden lg:block">
        <Image
          alt="Network effect background"
          className="object-cover"
          src="/images/NetworkEffect.jpg"
          fill
          priority
        />
      </div>

      {/* Content overlay */}
      <Card.Content className="relative z-10 px-10 py-6">
        <h2 className="text-neutral-strong type-h-section-md">
          {t('landingHeroCard.title')}
        </h2>
        <p className="text-neutral type-body-base">
          {t('landingHeroCard.description')}
        </p>
        <Button.Link
          className="mt-6"
          href={t('landingHeroCard.href')}
          size="base"
          variant="secondary"
        >
          <Icon className="mr-2" name="SparklesOutline" size={24} />
          {t('landingHeroCard.cta')}
        </Button.Link>
      </Card.Content>
    </Card>
  )
}
